import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=4c06010c&scoped=true&"
import script from "./SideNav.jsx?vue&type=script&lang=js&"
export * from "./SideNav.jsx?vue&type=script&lang=js&"
import style0 from "./SideNav.css?vue&type=style&index=0&lang=css&"
import style1 from "./SideNav.vue?vue&type=style&index=1&id=4c06010c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06010c",
  null
  
)

export default component.exports